'use client';

import { useCookies } from 'react-cookie';
import { PropsWithChildren, useCallback, useEffect } from 'react';
import { generateUUIDv4 } from '@/app/_utils/session/generate-uuid';
import { USER_TOKEN_KEY } from './constants';
import { UserTokenKeys, UserTokenValues } from './types';
import { UseUserTokenContext } from './user-token-context';
const UserTokenProvider = ({
  children
}: PropsWithChildren) => {
  const [cookies, setCookies] = useCookies<UserTokenKeys, UserTokenValues>([USER_TOKEN_KEY]);
  const userToken = cookies[USER_TOKEN_KEY] ?? null;
  const setUserToken = useCallback((userToken: string | null, isSecure = true) => {
    const oneYearFromNow = new Date();
    oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
    setCookies(USER_TOKEN_KEY, userToken, {
      httpOnly: false,
      secure: isSecure,
      sameSite: 'lax',
      expires: oneYearFromNow,
      path: '/'
    });
  }, [setCookies]);
  useEffect(() => {
    if (userToken || userToken === 'null') return;
    if (location.protocol === 'http:') {
      setUserToken('677b70fa-937d-4469-a812-edaafd36fa42', false);
      return;
    }
    setUserToken(generateUUIDv4());
  }, [setUserToken, userToken]);
  return <UseUserTokenContext.Provider value={{
    userToken,
    setUserToken
  }} data-sentry-element="unknown" data-sentry-component="UserTokenProvider" data-sentry-source-file="user-token-provider.tsx">{children}</UseUserTokenContext.Provider>;
};
export default UserTokenProvider;